module.exports = (__webpack_require__(71010))(24);